(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    function formatMoney(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const value = (cents / 100).toFixed(2);
  return '$' + value;  // agar aap PKR use karte ho
}
document.addEventListener('DOMContentLoaded', function () {

  const sizeButtons = document.querySelectorAll('.product-size-picker button');
  const productPrice = document.getElementById('product-price');
  const comparePrice = document.getElementById('compare-price');
  const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');

  // SIZE CLICK
  sizeButtons.forEach(btn => {
    btn.addEventListener('click', function () {

      // selected style
      sizeButtons.forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');

      // variant id change for cart
      // variant id change for cart
const variantId = this.dataset.variantId;
if (variantInput) {
  variantInput.value = variantId;

  // VERY IMPORTANT - notify Shopify theme
  variantInput.dispatchEvent(new Event('change', { bubbles: true }));
}

      // get price
      const price = parseInt(this.dataset.price);
      const compare = parseInt(this.dataset.comparePrice);

      // update selling price
      if (productPrice && !isNaN(price)) {
        productPrice.textContent = formatMoney(price);
      }

      // update compare price
      if (comparePrice) {
        if (compare && compare > price) {
          comparePrice.style.display = 'inline';
          comparePrice.textContent = formatMoney(compare);
        } else {
          comparePrice.style.display = 'none';
        }
      }

    });
  });


  // =========================
  // ACCORDION (your existing)
  // =========================
  const headers = document.querySelectorAll('.accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', function () {
      const item = this.parentElement;
      const isActive = item.classList.contains('active');

      document.querySelectorAll('.accordion-item').forEach(i => {
        if (i !== item) i.classList.remove('active');
      });

      item.classList.toggle('active');

      if (!isActive) {
        setTimeout(() => {
          const offset = 80;
          const top = item.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, 100);
      }
    });
  });

});


// For Sold Out Button


    // baki code same
  } catch(e) { console.error(e); }
})();

})();
